import React, { useEffect, useState } from "react";
import { Bell, BellOff } from "lucide-react";
import { EVENT, SOUND_SETS, feedbackOn, feedbackSet, setFeedbackOn, setFeedbackSet, previewSet } from "@/lib/feedbackSounds";

// Mutes or changes the right/wrong sounds everywhere; remembered on this device.
export const SoundToggle = ({ testId = "feedback-sound-toggle", className = "" }) => {
  const [on, setOn] = useState(feedbackOn);
  const [set, setSet] = useState(feedbackSet);
  useEffect(() => {
    const sync = () => { setOn(feedbackOn()); setSet(feedbackSet()); };
    window.addEventListener(EVENT, sync);
    return () => window.removeEventListener(EVENT, sync);
  }, []);
  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      <button type="button" onClick={() => setFeedbackOn(!on)} aria-pressed={on} data-testid={testId}
        title={on ? "Turn off the right/wrong sounds" : "Turn on the right/wrong sounds"}
        className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2.5 py-1 text-[11px] font-semibold normal-case tracking-normal transition-colors ${on ? "border-border text-muted-foreground hover:border-primary hover:text-primary" : "border-primary/50 bg-primary/10 text-primary"}`}>
        {on ? <Bell size={12} /> : <BellOff size={12} />} {on ? "Sounds on" : "Sounds off"}
      </button>
      {on && (
        <select value={set} onChange={(e) => { setFeedbackSet(e.target.value); previewSet(e.target.value); }} data-testid={`${testId}-set`} aria-label="Choose your right/wrong sound"
          className="rounded-full border border-border bg-background px-2 py-1 text-[11px] font-semibold normal-case tracking-normal text-muted-foreground hover:border-primary focus:border-primary focus:outline-none">
          {SOUND_SETS.map(([id, label]) => <option key={id} value={id}>{label}</option>)}
        </select>
      )}
    </span>
  );
};
